module.exports = __webpack_public_path__ + "img/virus.726ac157.svg";